import { colors } from './colors';

export const antdTheme = {
    token: {
        colorIcon: colors.text,
        colorText: colors.text,
        colorTextPlaceholder: colors.divider,
        colorBgContainer: colors.backgroundEmphasized
    },
    components: {
        Button: {
            borderColorDisabled: colors['success-600'],
            colorPrimary: colors['success-500'],
            colorPrimaryHover: colors['success-400'],
            colorPrimaryActive: colors['success-400'],
            colorBgContainerDisabled: colors['success-600'],
            colorPrimaryText: colors.background,
            colorText: colors.background,
            colorPrimaryTextActive: colors.background,
            defaultColor: colors.text,
            primaryColor: colors.background,
            colorTextBase: colors.text,
            textHoverBg: colors.transparent
        },
        Input: {
            addonBg: colors.backgroundEmphasized,
            activeBg: colors.backgroundEmphasized,
            activeBorderColor: colors.divider,
            colorBorder: colors.divider,
            colorSuccessBg: colors.backgroundEmphasized,
            colorPrimaryText: colors.text,
            colorText: colors.text,
            inputFontSize: 16,
            hoverBorderColor: colors.text,
            paddingBlockLG: 13,
            paddingInlineLG: 20
        },
        Select: {
            colorBorder: colors.divider,
            colorPrimaryBorderHover: colors.divider,
            colorPrimaryHover: colors.text,
            colorTextPlaceholder: colors.text,
            colorText: colors.background,
            optionSelectedBg: colors['grey-800'],
            paddingContentHorizontalLG: 20,
            padding: 20
        },
        Checkbox: {
            colorPrimary: colors['success-500'],
            colorPrimaryHover: colors['success-400']
        }
    }
};
